import { Box, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Card } from './types'

export const CardType = ({ card }: { card: Card }) => {
  return (
    <Box alignItems="center" flexDirection="row" gap="s8">
      {card.type === 'physical' && (
        <Tag type="grey">{i18n.t('expenses_v2.cards.type.short_physical')}</Tag>
      )}
      {card.type === 'virtual' && (
        <Tag type="grey">{i18n.t('expenses_v2.cards.type.short_virtual')}</Tag>
      )}
      {card.type === 'single_use' && (
        <Tag type="grey">{i18n.t('expenses_v2.cards.type.short_single_use')}</Tag>
      )}
    </Box>
  )
}
